import request from '@/utils/request'

/**
 * 短信接入方密钥信息分页
 * @param {*} params
 * @returns
 */
export const getSmsUserConfigPage = (params) => {
  return request({
    url: 'tools/v1/smsUserConfig/page-plus',
    params
  })
}

/**
 * 新增短信接入方密钥信息
 * @param {*} params
 * @returns
 */
export const saveSmsUserConfig = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsUserConfig/save',
    data
  })
}

/**
 * 修改短信接入方密钥信息
 * @param {*} params
 * @returns
 */
export const updateSmsUserConfig = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsUserConfig/update',
    data
  })
}

/**
 * 删除短信接入方密钥信息
 * @param {*} params
 * @returns
 */
export const delSmsUserConfig = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsUserConfig/delete',
    data
  })
}

/**
 * 短信接入方短信模板信息分页
 * @param {*} params
 * @returns
 */
export const getSmsTemplatePage = (params) => {
  return request({
    url: 'tools/v1/smsTemplate/page',
    params
  })
}

/**
 * 新增短信接入方短信模板信息
 * @param {*} params
 * @returns
 */
export const saveSmsTemplate = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsTemplate/save',
    data
  })
}

/**
 * 修改短信接入方短信模板信息(审核未通过)
 * @param {*} params
 * @returns
 */
export const updateSmsTemplate = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsTemplate/update',
    data
  })
}

/**
 * 修改短信接入方短信模板信息(审核已通过)
 * @param {*} data
 * @returns
 */
export const updatePlatSmsTemplate = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsTemplate/updatePlatSmsTemplate',
    data
  })
}

/**
 * 删除短信接入方短信模板信息
 * @param {*} params
 * @returns
 */
export const delSmsTemplate = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsTemplate/delete',
    data
  })
}

/**
 * 根据id获取短信模板消息
 * @param {*} params
 * @returns
 */
export const getSmsTemplateById = (id) => {
  return request({
    url: `tools/v1/smsTemplate/${id}`
  })
}

/**
 * 短信接入方签名信息分页筛选列表
 * @param {*} params
 * @returns
 */
export const getSmsSignNamePage = (params) => {
  return request({
    url: 'tools/v1/smsSignName/page',
    params
  })
}

/**
 * 新增短信签名信息
 * @param {*} params
 * @returns
 */
export const saveSmsSignName = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsSignName/save',
    data
  })
}

/**
 * 修改短信接入方短信模板信息
 * @param {*} params
 * @returns
 */
export const updateSmsSignName = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsSignName/update',
    data
  })
}

/**
 * 删除短信接入方短信模板信息
 * @param {*} params
 * @returns
 */
export const delSmsSignName = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsSignName/delete',
    data
  })
}

/**
 * 查询短信发送记录分页
 * @param {*} params
 * @returns
 */
export const getSmsRecordPage = (params) => {
  return request({
    url: 'tools/v1/smsRecord/page-plus',
    params
  })
}

/**
 * 根据id获取短信发送记录
 * @param {*} params
 * @returns
 */
export const getSmsRecordById = (id) => {
  return request({
    url: `tools/v1/smsRecord/${id}`
  })
}

/**
 * 查询短信模板的审核状态
 * @param {*} data
 * @returns
 */
export const querySmsTemplateAuditStatus = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/smsTemplate/querySmsTemplateAuditStatus',
    data
  })
}

/**
 * 同步短信平台模板列表
 * @param {*} appId
 * @returns
 */
export const asyncModule = (appId) => {
  return request({
    url: `tools/v1/smsTemplate/synchSmsTemplate/${appId}`
  })
}

/**
 * 同步短信平台模板列表
 * @param {*} appId
 * @returns
 */
export const asyncSign = (appId) => {
  return request({
    url: `tools/v1/smsSignName/synchSmsSignName/${appId}`
  })
}
